<div class="bonus">
    <img src="assets/wheel-of-fortune/wheel-bonus-market.png" alt="wheel of fortune" class="bonus__img">
    <p class="bonus__description">{{data().spins}} оберт</p>

<div class="mt-auto">
    @if(data().discount){
        <div class="discount">
            <span class="discount__former-price">{{data().old_price}} бонусів</span>
            <span class="discount__percent">-{{data().discount}}%</span>
        </div>
    }
    <p class="bonus__price">{{data().price}} бонусів</p>
    <button class="bonus__button" (click)="initSpinBuy()" [disabled]="data().price > balance()">Придбати</button>
</div>
</div>